import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface EmployeeHeaderProps {
  isNewEmployee: boolean;
}

export const EmployeeHeader = ({ isNewEmployee }: EmployeeHeaderProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {isNewEmployee ? 'New Employee Details' : 'Edit Employee Details'}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isNewEmployee ? 
          "Create a new employee profile by filling out the form below." : 
          "Update the employee's information using the form below."}
      </CardContent>
    </Card>
  );
};